module.exports = __webpack_public_path__ + "static/pink-logo-31d0d8a9addf4a19615d722b06f57d26.png";